export const SidebarStaticData = {
  dashboardText: 'Dashboard',
  sessionsText: 'Sessions',
  scheduleText: 'Schedule',
  chatText: 'Chat',
  myAccountText: 'My Account',
};

export const SidebarHindiData = {
  dashboardText: 'डैशबोर्ड',
  sessionsText: 'सेशंस',
  scheduleText: 'शेड्यूल',
  chatText: 'चैट',
  myAccountText: 'मेरा खाता',
};

export const SidebarArabicData = {
  dashboardText: 'لوحة التحكم',
  sessionsText: 'الجلسات',
  scheduleText: 'الجدولة',
  chatText: 'الدردشة',
  myAccountText: 'حسابي',
};
